import Vue from "vue";
import Router from "vue-router";

//引入pages页面
import Home from "@/pages/home";
import Search from "@/pages/search";
import Banner from "@/pages/banner";
import About from "@/pages/about";
import Wslndx from "@/pages/wslndx";
import News from "@/pages/news";
import oldAgeEducationPage from "@/pages/old_age_education";
import Form from "@/pages/form";
//引入子路由
import Leader from "@/components/about/Leader";
import WslndxLeader from "@/components/wslndx/WslndxLeader";
import NewsMenu from "@/components/NewsMenu";
import NewsContent from "@/components/NewsContent";
import EducationContent from "@/components/old_age_education/EducationContent";

Vue.use(Router);

const router = new Router({
  // mode: history,
  routes: [
    {
      path: "/",
      name: "HomePage",
      // component: resolve => require(["@/pages/home"], resolve),
      component: Home
    },
    {
      path: "/search/:searchContent/:random",
      name: "SearchPage",
      component: Search
    },
    {
      path: "/info/:banner/:bannerId",
      name: "BannerPage",
      component: Banner
    },
    {
      path: "/about",
      name: "AboutPage",
      component: About,
      redirect: "/about/0",
      children: [
        {
          path: ":menu",
          component: Leader,
          props: true
        }
      ]
    },
    {
      path: "/wslndx",
      name: "WslndxPage",
      component: Wslndx,
      redirect: "/wslndx/0",
      children: [
        {
          path: ":menu",
          component: WslndxLeader,
          props: true
        }
      ]
    },
    {
      path: "/:type",
      name: "NewsPage",
      component: News,
      redirect: "/:type/0",
      children: [
        {
          path: ":menu",
          component: NewsMenu,
          props: true
        },
        {
          path: ":menu/:articletitle",
          component: NewsContent,
          props: true
        }
      ]
    },
    {
      path: "/old_age_education",
      name: "oldAgeEducationPage",
      component: oldAgeEducationPage,
      redirect: "/old_age_education/0",
      children: [
        {
          path: ":menu",
          component: NewsMenu,
          props: true
        },
        {
          path: ":menu/:articletitle",
          component: NewsContent,
          props: true
        },
        {
          path: ":menu/:articletitle/:currentPage",
          component: EducationContent,
          props: true
        }
      ]
    },
    {
      // 会员登录会员注册
      path: "/online_service",
      name: "OnlineServicePage",
      component: News,
      redirect: "/online_service/0",
      children: [
        {
          path: ":menu",
          component: NewsMenu,
          props: true
        },
        {
          path: ":menu/:articletitle",
          component: Form,
          props: true
        }
      ]
    },
    {
      path: "/detail/:mold/:rank/:id/*",
      redirect: to => {
        console.log(to);
        // if (to.params.mold == "info") {
        // }
        return to.params.mold + "/" + to.params.rank + "/" + to.params.id;
      }
    },
    {
      path: "*",
      redirect: "/"
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  next();
  // if (process.env.NODE_ENV === 'development' || to.path === '/') {
  //   next();
  // } else {
  //   /*线上环境暂时不允许访问除首页外*/
  // }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js